import KaamvalaLogo from '../assets/kaamvala-logo.png'
import forgotPassImage from '../assets/forgotPassImage.png'
import loginAuthImage from '../assets/loginAuthImage.png'
import openEye from '../assets/openEye.png'
import closeEye from '../assets/closeEye.png'
import PadLock from '../assets/Padlock.png'
import totalRevenue from '../assets/totalRevenue.png'
import upGraph from '../assets/upGraph.svg'
import downGraph from '../assets/downGraph.svg'
import hamburger from '../assets/hamburger.png'

export const Images = {
    kaamvala_logo: KaamvalaLogo,
    loginAuth_Image: loginAuthImage,
    Pad_Lock: PadLock,
    forgot_pass: forgotPassImage,
    open_eye: openEye,
    close_eye: closeEye,
    total_Revenue: totalRevenue,
    upGraph: upGraph,
    downGraph: downGraph,
    hamburger:hamburger
}